import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'

@Component({
	selector: 'app-floating-button',
	templateUrl: './floating-button.component.html',
	styleUrls: ['./floating-button.component.scss'],
})
export class FloatingButtonComponent implements OnInit {

	@Input()
	private btnLink: string|null

	@Output()
	private btnClick: EventEmitter<Event> = new EventEmitter();

	@Input()
	public btnPosition: number

	/** TODO Feather Icons als Enum implementieren */
	@Input()
	public btnIcon: string|null

	/** TODO Übersetzungen besser kapseln */
	@Input()
	public btnTitle: string|null

	public floatingButtonLink: string
	public floatingButtonClick: ($event: Event) => void
	public floatingButtonTarget: string|null

	ngOnInit(): void {
		this.floatingButtonLink = this.btnLink ?? null
		this.floatingButtonTarget = this.btnLink ? '_blank' :  null
		this.floatingButtonClick = (e: Event) => this.btnClick.emit(e)
	}
}
